import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {SearchAutoCompleteItemProps} from './SearchAutoCompleteItemProps.interface';

export function SearchAutoCompleteItem({
  searchKeyword,
  autoCompleteKeyword,
  isMobile,
  className,
  ...props
}: SearchAutoCompleteItemProps) {
  const matchKeywordIndex = autoCompleteKeyword.indexOf(searchKeyword);
  return (
    <div
      className={twMerge(
        'flex h-44pxr cursor-pointer items-center text-theme-solid-100',
        !isMobile && 'pl-8pxr hover:rounded-4pxr hover:bg-theme-bg-surface-alt',
        className
      )}
      {...props}
    >
      <div className="break-all line-clamp-1">
        <Text className={isMobile ? 'font-medium2' : 'font-small1'}>
          {autoCompleteKeyword.slice(0, matchKeywordIndex)}
        </Text>
        <Text className={isMobile ? 'font-medium2-bold' : 'font-small1-bold'}>
          {searchKeyword}
        </Text>
        <Text className={isMobile ? 'font-medium2' : 'font-small1'}>
          {autoCompleteKeyword.slice(matchKeywordIndex + searchKeyword.length)}
        </Text>
      </div>
    </div>
  );
}
